export default "__VITE_ASSET__DYnEgKBF__"